// extracted by mini-css-extract-plugin
export default {"form":"_13jtw"};